<template>
	<div class="noselect">
		<VueSignaturePad
			class="bg-gray-300 mx-auto my-4 signature-pad"
			ref="signaturePad"
			:options="options"
			@onEnd="onEnd"
			v-if="!isAppContainer"
			:class="{ 'ml-0': alignLeft }"
		/>
		<div
			@click="openSignPad"
			style="height: 150px"
			:class="signaturePad"
			class="bg-gray-300 rounded mx-auto my-4 bg-cover"
			ref="appcontainer-signpad"
			v-else
		>
			<div class="flex justify-center flex-col h-full text-center" v-if="!value">
				{{ $t('click_to_sign') }}
			</div>
			<div class="bg-cover w-full h-full" :style="{ 'background-image': 'url(' + value + ')' }" />
		</div>

		<div v-if="true" class="w-full flex" :class="alignLeft ? 'justify-start' : 'justify-center'">
			<BaseButton @click="clear">{{ $t('delete') }}</BaseButton>
		</div>
	</div>
</template>

<script>
import BaseButton from '@/components/forms/buttons/BaseButton';
import mergeImages from 'merge-images';

export default {
	name: 'BaseSign',
	components: { BaseButton },
	created() {
		window.addEventListener('resize', this.reRenderSignField);
	},
	destroyed() {
		window.removeEventListener('resize', this.reRenderSignField);
	},
	data() {
		return {
			options: {
				penColor: '#000',
				onEnd: this.onEnd,
			},
			appcontainerSign: null,
			timeoutId: null,
		};
	},
	props: {
		value: null,
		backgroundImage: null,
		signaturePad: { default: 'signature-pad' },
		alignLeft: { required: false, default: false },
	},
	mounted() {
		if (this.value && !window.appcontainer.isiOSAppcontainer) {
			this.$refs.signaturePad.fromDataURL(this.value);
		}
	},
	methods: {
		reRenderSignField() {
			this.$nextTick(function() {
				if (!window.appcontainer.isiOSAppcontainer) {
					if (this.value) {
						this.$refs.signaturePad.fromDataURL(this.value);
					}
					this.$refs.signaturePad.resizeCanvas();
				}
			});
		},
		openSignPad() {
			if (window.appcontainer.isiOSAppcontainer) {
				window.appcontainer.openSignaturePad();
				window.addEventListener(
					'didSignSignaturePad',
					event => {
						this.$emit('input', event.detail);
						this.appcontainerSign = event.detail;
					},
					{ once: true },
				);
			}
		},
		clear() {
			if (!window.appcontainer.isiOSAppcontainer) {
				this.$refs.signaturePad.clearSignature();
			}
			this.$emit('input', null);
			this.$emit('clear');
		},
		undo() {
			this.$refs.signaturePad.undoSignature();
			this.$emit('input', null);
		},
		onEnd() {
			const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
			clearTimeout(this.timeoutId);
			this.timeoutId = setTimeout(() => {
				this.$emit('input', data);
			}, 800);
		},
		imageToDataUri(b64, width, height) {
			return new Promise((resolve, reject) => {
				if (!b64) {
					return resolve(null);
				}

				const image = new Image();
				image.onerror = reject;
				image.src = b64;

				image.onload = () => {
					// create an off-screen canvas
					const canvas = document.createElement('canvas');
					const ctx = canvas.getContext('2d');

					// set its dimension to target size
					canvas.width = width;
					canvas.height = height;

					// draw source image into the off-screen canvas:
					ctx.drawImage(image, 0, 0, width, height);

					// encode image to data-uri with base64 version of compressed image
					resolve(canvas.toDataURL());
				};
			});
		},
		mergeSignWithBackground() {
			const clientWidth = this.$refs['appcontainer-signpad'].clientWidth;
			const clientHeight = this.$refs['appcontainer-signpad'].clientHeight;
			if (!this.backgroundImage) {
				return this.value;
			}
			this.imageToDataUri(this.backgroundImage, clientWidth, clientHeight).then(response => {
				mergeImages(
					[response, this.appcontainerSign].filter(el => el !== null),
					{
						width: clientWidth,
						height: clientHeight,
					},
				)
					.then(b64 => {
						this.$emit('input', b64);
					})
					.catch(error => console.log(error));
			});
		},
	},
	watch: {
		value() {
			if (this.value) {
				if (!window.appcontainer.isiOSAppcontainer) {
					this.$nextTick(function() {
						this.$refs.signaturePad.fromDataURL(this.value);
					});
					//this.$refs.signaturePad.resizeCanvas();
				} else {
					this.mergeSignWithBackground();
				}
			} else {
				this.appcontainerSign = null;
			}
		},
		backgroundImage: function(before, after) {
			if (this.backgroundImage !== null) {
				if (!window.appcontainer.isiOSAppcontainer) {
					this.$refs.signaturePad.fromDataURL(this.backgroundImage);
					this.$emit('input', this.backgroundImage);
				} else {
					this.mergeSignWithBackground();
				}
			}
		},
	},
	computed: {
		isAppContainer() {
			return window.appcontainer.isiOSAppcontainer;
		},
		model: {
			get() {
				return this.value;
			},
			set(v) {
				this.$emit('input', v);
			},
		},
	},
};
</script>
